import { render, staticRenderFns } from "./InviteFooter.vue?vue&type=template&id=26a5e704&"
import script from "./InviteFooter.vue?vue&type=script&lang=js&"
export * from "./InviteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports